import {Component, Input, NgZone} from '@angular/core';
import {Item} from "../../../../interfaces/proyecto.interface";
import {AsyncPipe, DecimalPipe, NgClass} from "@angular/common";
import {ProgressBarModule} from "primeng/progressbar";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {shareReplay, timer} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {TagModule} from "primeng/tag";
import {ScrollerModule} from "primeng/scroller";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {TimeAgoAtPipe} from "../services/time-ago-at.pipe";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {TagSemaphorePipe} from "../services/tag-semaphore.pipe";

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.locale('es')
dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
    selector: 'app-items',
    standalone: true,
    imports: [
        DecimalPipe,
        ProgressBarModule,
        TagModule,
        ScrollerModule,
        ScrollPanelModule,
        TimeAgoAtPipe,
        AsyncPipe,
        NgClass,
        TagSemaphorePipe
    ],
    templateUrl: './items.component.html',
    styleUrl: './items.component.scss'
})
export class ItemsComponent {
    @Input({required: true}) items: Item[] = [];
    readonly now$ = this.zone.runOutsideAngular(() =>
        timer(this.msToNextMidnight(), 86_400_000)
    ).pipe(startWith(0), map(() => Date.now()), shareReplay({bufferSize: 1, refCount: true}));

    private msToNextMidnight() {
        const n = new Date();
        const m = new Date(n);
        m.setHours(24, 0, 0, 0);
        return +m - +n;
    }

    constructor(private zone: NgZone) {
    }

    private readonly estadoColorMap: Record<string, string> = {
        'Eliminado': '#a90911',
        'En carrito': 'rgb(208,136,5)',
        'Formulario pendiente': '#ea5b02',
        'Formulario completo': 'rgba(48,127,239,0.93)',
        'Pago realizado': '#569400',
        'Pago no requerido': '#569400'
    };

    getColorEstadoTramite(estado: string | null): string {
        if (!estado) return '#A4ABB6';
        return this.estadoColorMap[estado] ?? '#A4ABB6';
    }

    getHeight(items: Item[]) {
        if (items.length == 1) {
            return '50px';
        } else if (items.length == 2) {
            return '100px';
        } else {
            return '150px';
        }
    }
}
